"use strict";function joinClassroom$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.joinClassroom$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.edu.joinClassroom";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.15"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.15"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"6.0.15"},_a)),exports.joinClassroom$=joinClassroom$,exports.default=joinClassroom$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/edu/joinClassroom.js
// module id = 948
// module chunks = 106